import type { OptionItem } from "@/api/admin";

export const getIdsForFilter = (items?: (OptionItem | string)[]) =>
  items?.map(item =>
    typeof item === "object" && "id" in item ? item.id : item
  ) || [];
